let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
import i18n from "../utils/i18n";
import pos from "../POS.js";

let main = function () {
    //This is a hack!, not sure why $ is not initialised with Backbone
    Backbone.$ = $;
    return Backbone.View.extend({
        el: "#screenAlertModal",

        init: function () {
            this._onWindowResizeDebounced = _.debounce(this.onWindowResize, 500);
            $(window).on("resize", this._onWindowResizeDebounced.bind(this));
            this._onWindowResizeDebounced();

            // if user's browser is not chrome, alert a message tell we only support chrome
            var browserString = navigator.userAgent.toLowerCase();
            if (browserString.indexOf('chrome') < 0  &&browserString.indexOf('safari') < 0  &&browserString.indexOf('firefox') < 0 &&browserString.indexOf('msie 9.0') < 0 &&browserString.indexOf('msie 10.0') < 0 &&browserString.indexOf('rv:11.0') < 0 &&browserString.indexOf('ipad') < 0 && !this._isRunningAndroidEmbedded()) {
                if (browserString.indexOf("android") < 0) {
                    this.recommendedChrome();
                } else {
                    this.recommendedChromeAndroid();
                }
            }
        },

        _text: function (text) {
            this.$(".modal-body p").html(text);
            return this;
        },

        onWindowResize: function () {
            // compact nav bar if screen width is not enough
            var nav = $("nav.navbar"), mainMenu = nav.find(".mainMenu"), gap = 10;
            if (this.unCompactedSize == null) {
                this.unCompactedSize = mainMenu.outerWidth();
            }
            if ((window.innerWidth < 768) && pos.checkFeature("BASE") && !pos.get("branded")) {
                //if (confirm(i18n.msg("pos.alert.screesize"))) {
                    window.location.href = "#mobile";
                //}
            }
        },
        _isRunningAndroidEmbedded: function () {
            var browserString = navigator.userAgent.toLowerCase();
            return browserString.indexOf("533.1") > 0;
        },

        recommendedChrome: function () {
            this._text(i18n.msg("pos.alert.browser")).$el.modal("show");
        },

        recommendedChromeAndroid: function () {
            this._text(i18n.msg("pos.alert.browser.android")).$el.modal("show");
        },

        recommendedChromeForPrint: function () {
            this._text(i18n.msg("pos.alert.browserForPrint")).$el.modal("show");
        }
    });

    //return new EnvironmentMonitorView();
};

let exportedValue = main();
export default exportedValue;




// WEBPACK FOOTER //
// ./src/view/EnvironmentMonitorView.js